import React from 'react';
import {Col, Form, FormGroup, Label, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../Store/Reducers";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {ModalActions} from "../../../Store/Modal/Slice";
import {CANCEL_SHIPMENT_MODAL} from "../../../Store/Modal/Types";
import InputErrorsComponent from "../Inputs/InputErrorsComponent";
import ModalFooterWithButtons from "../ModalFooterWithButtonsComponent";
import {PickupActions} from "../../../Store/Pickup/Slice";
import {toast} from "../../../Utils/Utils";
import moment from "moment";

interface IComment {
  comment: string;
}

const CancelShipmentModal = () => {

  const dispatch = useDispatch();

  const {
    ModalReducer: {cancelShipmentModal: {open, data}},
    LoadingReducer: {loadingCancelShipment}
  } = useSelector((state: RootState) => state);

  const form = useForm<IComment>({mode: "all"});
  const {handleSubmit, register, errors} = form;

  const onClose = (data?: IComment) => {
    dispatch(ModalActions.closeModal({
      modal: CANCEL_SHIPMENT_MODAL,
      result: data
    }));
  };

  const onSubmit: SubmitHandler<IComment> = (comment: IComment) => {
    if (!comment) {
      return toast('Ingrese un comentario', 'error');
    }
    const systemMessage = `${moment().format("DD-MM-YYYY - h:mm:ss a")} - Guía eliminada por el cliente`;
    const params = {
      ...data,
      comment: data.comment
        ? `${data.comment}\n ${systemMessage} \n${comment.comment}`
        : `${systemMessage}\n${comment.comment}`};
    dispatch(PickupActions.cancelPickup(params));
  };

  return (
    <Modal isOpen={open} size="SM">
      <ModalHeader className="border-0">AGREGUE UN COMENTARIO</ModalHeader>
      <ModalBody>
        <FormProvider {...form}>
          <Form>
            <Row>
              <Col>
                <FormGroup>
                  <Label>OBSERVACIONES <sup>*</sup></Label>
                  <textarea
                    className="form-control"
                    name="comment"
                    rows={6}
                    required
                    ref={register({required: true, minLength: 1})}
                  />
                  <InputErrorsComponent name="observations" errors={errors} rules={{required: true, minLength: 1}}/>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </FormProvider>
      </ModalBody>
      <ModalFooterWithButtons
        onSave={handleSubmit(onSubmit)}
        isLoading={loadingCancelShipment.status.isLoading()}
        disabledSave={loadingCancelShipment.status.isLoading()}
        onClose={() => onClose()}
      />
    </Modal>
  )
};


export default CancelShipmentModal;
